/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_identity_mode_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server Identity Mode`)
};

const zh_hans1_settings_minecraft_identity_mode_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务器身份模式`)
};

const zh_hant1_settings_minecraft_identity_mode_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`伺服器身份模式`)
};

const fr_settings_minecraft_identity_mode_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode d'identité serveur`)
};

const de_settings_minecraft_identity_mode_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server-Identitätsmodus`)
};

const ja_settings_minecraft_identity_mode_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバー識別モード`)
};

const ko_settings_minecraft_identity_mode_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서버 신원 모드`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_identity_mode_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_identity_mode_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_identity_mode_title", locale)
	if (locale === "en") return en_settings_minecraft_identity_mode_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_identity_mode_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_identity_mode_title(inputs)
	if (locale === "fr") return fr_settings_minecraft_identity_mode_title(inputs)
	if (locale === "de") return de_settings_minecraft_identity_mode_title(inputs)
	if (locale === "ja") return ja_settings_minecraft_identity_mode_title(inputs)
	return ko_settings_minecraft_identity_mode_title(inputs)
};